import { HugeiconsIcon } from "@hugeicons/react";
import { IconSvgElement } from "@hugeicons/react";

export const IconAI = ({
  bgSize = 44,
  icon
}: {
  bgSize?: number;
  icon?: {
    size?: number;
    Icon: IconSvgElement;
    strokeWidth?: number;
  };
}) => {
  const iconSize = icon?.size ?? Math.round(bgSize * (24 / 44));

  return (
    <i
      className="ai-icon-bg shrink-0 flex items-center justify-center"
      style={{ width: bgSize, height: bgSize }}
    >
      {icon ? (
        <div className="relative">
          <div
            data-purpose="icon-flare"
            className="absolute rounded-full left-0 top-0 translate-x-1/2 bg-[#FFF8FD]"
            style={{
              width: bgSize * 0.11,
              height: bgSize * 0.11,
              filter: `blur(${Math.max(1, bgSize * 0.045)}px)`
            }}
          />
          <HugeiconsIcon
            size={iconSize}
            strokeWidth={icon.strokeWidth}
            icon={icon.Icon}
            className="ai-icon-bg-nested"
          />
        </div>
      ) : null}
    </i>
  );
};
